import { useAuth } from "../hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";
export const ProtectedRouteSebrae = ({ children }) => {
    const { user, isUsuarioSebrae } = useAuth();
    const location = useLocation();

    if ((location.pathname === "/dashboard/pagamento-direto" && user.role_id == 6) || (location.pathname === "/dashboard/criar-pagamento-direto" && user.role_id == 6)) {
      return children;
    }

    if (!user) {
      return <Navigate to="/dashboard/painel-notas" replace />;
    }

    if (user && !isUsuarioSebrae) {
        return <Navigate to="/dashboard/painel-notas" replace />;
    }
  
    return children;
  };